export default {"src":"/_next/static/media/sony_logo.9edd72b0.svg","height":2500,"width":2500};